<template>
	<el-dialog :close-on-click-modal="false" :append-to-body="true" class="auth-dialog" title="签署认证"
		:visible.sync="dialogVisible" width="530px">
		<div class="main-auth">
			<div class="auth-nav clearfix">
				<a href="javascript:;" :class="{ active: itemActive == 'sms' }" @click="changeActive('sms')">短信</a>
				<a href="javascript:;" :class="{ active: itemActive == 'pin' }" @click="changeActive('pin')">签署密码</a>
			</div>
			<div class="auth-pane">
				<div class="auth-pane-item" v-show="itemActive == 'sms'">
					<el-form @submit.native.prevent :model="smsForm" :rules="smsRules" ref="smsForm" class="sms-Form">
						<div class="phone-text">您绑定的手机号 {{ phone }}</div>
						<el-form-item prop="code" style="position:relative;">
							<el-input size="small" placeholder="输入验证码" maxlength="6"  v-model="smsForm.code"></el-input>
							<div class="code-btn">
								<el-button type="primary" plain size="small" :disabled="sendAuthCode"
									@click="getMsgAuthCode()" v-show="!sendAuthCode">获取验证码</el-button>
								<el-button type="primary" plain size="small" :disabled="sendAuthCode" v-show="sendAuthCode">
									{{ auth_time }}秒</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>

				<div class="auth-pane-item" v-show="itemActive == 'pin'">
					<el-form @submit.native.prevent :model="pinForm" :rules="pinRules" ref="pinForm" class="pin-Form">
						<el-form-item prop="pin" style="position:relative;">
							<el-input size="small" placeholder="输入签署密码（6位数字）" show-word-limit maxlength="6" type="password" v-model="pinForm.pin"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="dialog-btns">
				<el-button size="small" type="primary" @click="submitHandle" class="btn-ok">确认</el-button>
				<el-button size="small" @click="cancel">取消</el-button>
			</div>
		</div>

	</el-dialog>
</template>
<script>
import { getSmsVerificationCode } from "@/api/common";
import {
	getAuthTokenBySmsVerificationCode,
	getAuthTokenByPin
} from "@/api/sign/sign";
import { mapState } from "vuex";
export default {
	props: {
		signId: String
	},
	data() {
		return {
			dialogVisible: false,
			smsForm: {
				code: ""
			},
			pinForm: {
				pin: ""
			},
			itemActive: "sms",
			sendAuthCode: false,
			auth_time: 60,
			smsRules: {
				code: [
					{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}
				]
			},
			pinRules: {
				pin: [
					{
						required: true,
						message: "请输入签署密码",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {
		phone() {
			var str1 = "";
			if (this.userInfo.phone) {
				str1 = this.userInfo.phone.replace(
					/(\d{3})(\d+)(\d{4})/,
					function (x, y, z, p) {
						var i = "";
						while (i.length < z.length) {
							i += "*";
						}
						return y + i + p;
					}
				);

				return str1;
			}
		},
		...mapState(["userInfo"])
	},
	methods: {
		getMsgAuthCode() {
			this.sendAuthCode = false;
			getSmsVerificationCode({
				bizType: "signAuthToken"
			})
				.then(res => {
					if (res.code !== 200) {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning"
						});
						this.sendAuthCode = false;
						this.auth_time = 59;
					} else {
						this.$message({
							message: "短信发送成功",
							type: "success"
						});
						// 倒计时
						this.auth_time = 60;
						this.sendAuthCode = true;
						let auth_timer = setInterval(() => {
							this.auth_time--;
							if (this.auth_time <= 0) {
								this.sendAuthCode = false;
								clearInterval(auth_timer);
							}
						}, 1000);
					}
				})
				.catch(err => {
					console.log(err);
					// this.$message.error('服务器错误！');
				});
		},
		changeActive(type) {
			this.itemActive = type;
		},
		submitHandle() {
			if (this.itemActive == "sms") {
				this.$refs["smsForm"].validate(valid => {
					if (valid) {
						getAuthTokenBySmsVerificationCode({
							vcode: this.smsForm.code,
							signId: this.signId
						}).then(res => {
							if (res.code != "200") {
								this.$message({
									showClose: true,
									message: res.message,
									type: "warning"
								});
							} else {
								// this.$message({
								// 	showClose: true,
								// 	message: res.message,
								// 	type: "success"
								// });
								this.$emit("getAuthCode", {
									signAuthToken: res.data.signAuthToken
								});
								this.cancel();
							}
						});
					} else {
						console.log("error submit!");
						return false;
					}
				});
			} else if (this.itemActive == "pin") {
				this.$refs["pinForm"].validate(valid => {
					if (valid) {
						getAuthTokenByPin({
							pin: this.pinForm.pin,
							signId: this.signId
						}).then(res => {
							if (res.code != "200") {
								this.$message({
									showClose: true,
									message: res.message,
									type: "warning"
								});
							} else {
								// this.$message({
								// 	showClose: true,
								// 	message: res.message,
								// 	type: "success"
								// });
								this.$emit("getAuthCode", {
									signAuthToken: res.data.signAuthToken
								});
								this.cancel();
							}
						});
					} else {
						console.log("error submit!");
						return false;
					}
				});
			}
		},

		cancel() {
			this.dialogVisible = false;
			this.smsForm.code = "";
			this.pinForm.pin = "";
			this.$emit("cancel");
		}
	}
};
</script>
<!-- <style lang="scss">
.auth-dialog {
	.el-dialog {
		border-radius: 4px;
	}
}
</style> -->

<style lang="scss" scoped>
// .main-auth {
// 	padding: 10px 35px 20px;
// }
.auth-nav {
	width: 100px;
	// margin: 0 auto;
}

.auth-nav a {
	color: #999999;
	// font-size: 16px;
	float: left;
	padding-bottom: 5px;
}

.auth-nav a:last-child {
	float: right;
}

.auth-nav a.active {
	border-bottom: 2px solid #3F7BF9;
	color: #3F7BF9;
}

.sms-Form,
.pin-Form {
	margin: 20px auto 0;
}

.phone-text {
	color: #333333;
	font-size: 14px;
	margin-bottom: 20px;
}

.code-btn {
	position: absolute;
	right: 0;
	top: 0;

	.el-button {
		// height: 38px;
		// padding: 0;
		// width: 100px;
		border-radius: 0 3px 3px 0;
		// border: none;
	}
}

// .dialog-btns {
// 	width: 100%;
// 	margin: 40px auto 0;
// 	display: flex;
// 	justify-content: space-between;
// 	overflow: hidden;
// 	.el-button {
// 		padding: 12px 60px;
// 	}
// }

// .dialog-btns button {
// 	display: block;
// 	width: 179px;
// 	height: 50px;
// 	font-size: 18px;
// 	border-radius: 10px;
// 	float: left;
// }

// .dialog-btns button.last-child {
// 	float: right;
// }
</style>
